import APIService from "@/services/APIService.js";

const apiRelatorio = APIService.create({
  baseURL: process.env.VUE_APP_API_URL + "/admin/relatorio"
});

export default {
  getAll(filters) {
    return apiRelatorio.get("", {
      params: {
        ...filters
      }
    });
  },
  getContatos(limit, page, filters, data, grafico) {
    return apiRelatorio.get("/contatos", {
      params: {
        data: data,
        grafico: grafico,
        limit: limit,
        offset: page * limit - limit,
        sort_by: "nome",
        ...filters
      }
    });
  }
};
